import { observer } from 'mobx-react-lite'
import { Stack, Typography } from '@mui/material';
import StoreReferral from '../../Stores/StoreReferral';
import { T } from 'GlobalStores/Cores/Translator/useTranslate';
import storeAuth from 'GlobalStores/User/StoreAuth';
import { useNavigate } from 'react-router';
import { storeElement } from 'GlobalStores/StoreElement';
import { language } from 'GlobalStores/Language/StoreLanguage';
import StoreFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat';
import { ReactComponent as Exclamation } from '../../Assets/Svgs/exclamation.svg'

const LoginFooter = observer(() => {
    const navigate = useNavigate()

    return StoreReferral.HasReferral() === false ? (

        <Stack
            sx={{
                backgroundColor: '#FFF1DC',
                justifyContent: 'center',
            }}
            p={storeElement.dynamicWidth < 700 ? '15px 20px' : '20px 50px'}
        >
            <Stack flexDirection={'row'}>
                <Stack justifyContent={'center'} paddingRight={'20px'}>
                    <Exclamation />
                </Stack>

                <Stack>
                    <Stack sx={{ flexDirection: "row", fontWeight: "400", fontSize: "14px", lineHeight: "18px" }}>
                        <Typography
                            component="p"
                            variant="caption"
                            sx={{ color: "#003B6F", textAlign: "left" }}
                        >
                            <T>login_footer_desc_1</T>{" "}

                            <Typography
                                sx={{
                                    textDecoration: 'underline', color: "#5A8FC3", textAlign: "left",
                                    cursor: 'pointer'
                                }}
                                variant="caption"
                                component="a"
                                href={language.listenObject(StoreFeelGreat?.contents?.quickLinks?.items?.find(item => item?.title.english === 'Customer support')?.items[0].externalLink)}

                            >
                                <T>login_footer_cs</T>
                            </Typography>
                        </Typography>


                    </Stack>

                    <Typography

                        variant="caption"
                        sx={{ mt: "6px", color: "#33628C", fontSize: "12px", lineHeight: "16px", textAlign: "left" }}
                    >
                        <T>login_footer_desc_2</T>
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    ) : null
})

export default LoginFooter